// src/utils/calcCotation.js
// Version LITE : pas de règles métiers, pas d'ajout auto, pas de coûts.

export function calcCotation(input = {}) {
  const acts = input.acts || input.actes || [];
  const userMajos = input.userMajos || input.majorations || [];
  const domaine = input.domaine || input.domain || null;

  // On accepte ce qui est passé, en normalisant.
  const countedActes = Array.isArray(acts) ? acts : [];
  const appliedMajos = (Array.isArray(userMajos) ? userMajos : [userMajos])
    .filter(Boolean)
    .map((m) => String(m).toUpperCase());

  // On ne renvoie plus de prix/depassement (mettez 0 si votre UI l’attend).
  return {
    domaine,
    countedActes,
    appliedMajos,
    depassement: 0,
    prixTotal: null,
  };
}
